import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
Vue.use(ElementUI, {
  i18n: (key, value) => {
    i18n.t(key, value);
  },
});

import preventReClick from "./assets/js/preventReClick"; //防多次点击，重复提交

Vue.config.productionTip = false;

// 公共过滤器
import * as filters from "./plugin/filter.js";
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key]);
});
// 处理数字公式
import globalVariable from "./plugin/globalVariable";
Vue.prototype.commonsVariable = globalVariable;

// 全局方法
// 处理图片
Vue.prototype.handleReplaceURL = function (str) {
  let old_url = ["http://58.87.104.85:9192/static/"];
  if (old_url.length) {
    var is_has_img = str.search(/<img /i) >= 0;
    if (is_has_img) {
      old_url.forEach((item) => {
        str = str.replace(item, "https://statics.successkaoyan.com/static/");
      });
      return str;
    } else {
      return str;
    }
  } else {
    return str;
  }
};

import i18n from "./components/i18n";

new Vue({
  router,
  store,
  preventReClick,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
